import React, { useEffect, useState } from "react";
import setting from "../../../../assets/images/setting.png";
import { CircularProgress, Paper } from "@material-ui/core";
import SettingsIcon from "@mui/icons-material/Settings";
import AddIcon from "@material-ui/icons/Add";
import { DataGrid } from "@mui/x-data-grid";
import { ManageBreakDownTableColumns } from "../../../tableColumns/ManageBreakDownTableColumns";
import CustomSearch from "../../../../Common/CustomSearch";
import { useDispatch, useSelector } from "react-redux";
import { OpenBreakDownPopup } from "../../../../Redux/Actions/BreakDownActions";
import AddOrEditBreakDown from "../../Popups/AddOrEditBreakDown";
import {
  breakDownTableTableLoading,
  isEditBreakDownValue,
  setBreakDownList,
  setEditBreakDownInformation,
  setSearchedBreakDownList,
  setSearchedBreakdownStatus,
  toggleAddOrEditBreakDownPopUp,
} from "../../../../Redux/Actions/ManageBreakDownAction";
import DialogBox from "../../Popups/ReusablePopup/DialogBox";
import styles from "./ManageBreakdown.module.css";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import { FaTimes } from "react-icons/fa";

const ManageBreakDownModel = () => {
  const currentUserId = getFromLocalStorage("currentUserId");
  const schoolId = getFromLocalStorage("schoolId");
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const {
    searchedRecord,
    pageState: BreakDownList,
    tableLoading,
    loading,
  } = useSelector((state) => state?.manageBreakDownData?.breakDownTable);
  const BreakDownData = useSelector((state) => state?.breakDownInformation);
  const { selectedColumnSet } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );
  useEffect(() => {
    if (BreakDownData?.setOpen) {
      setBreakDownList(dispatch, {
        page: BreakDownList?.page,
        pageSize: BreakDownList?.pageSize,
        currentUserId,
        defaultColumnSetName: selectedColumnSet?.columnName,
      });
      breakDownTableTableLoading(dispatch, true);
    }
  }, [BreakDownData?.setOpen]);

  const searchBreakDownData = (query, page, size) => {
    setSearchedBreakDownList(dispatch, {
      query,
      page,
      pageSize: size,
      schoolId,
      defaultColumnSetName: selectedColumnSet?.columnName,
    });
  };

  const setSearchedRecord = (status) => {
    setSearchedBreakdownStatus(dispatch, status);
  };

  const handleRowClick = (param) => {
    toggleAddOrEditBreakDownPopUp(dispatch, true);
    isEditBreakDownValue(dispatch, true);
    setEditBreakDownInformation(dispatch, param?.row);
  };
  return (
    <div>
      <button
        className="saveBtn1"
        onClick={() => {
          OpenBreakDownPopup(dispatch, true);
        }}
      >
        Manage BreakDown Data
        <SettingsIcon className="mg-left-10 addIconSc" />
      </button>

      {/* <span
        className="link mr-3  video-text  card-box-style mobile-btns-for-vp"
        onClick={() => {
          OpenBreakDownPopup(dispatch, true);
        }}
      >
        Manage BreakDown
        <img className="cp tabs" src={setting} alt="menu" />
      </span> */}
      <DialogBox
        open={BreakDownData.setOpen}
        onClose={() => OpenBreakDownPopup(dispatch, false)}
        variant="md"
        title={
          <div className="d-flex-space-between">
            <p className="bold">Manage Breakdown</p>
            <FaTimes
              onClick={() => OpenBreakDownPopup(dispatch, false)}
              className="crossview cp"
            />
          </div>
        }
      >
        <div className="position-relative">
          {!tableLoading && (
            <>
              <div className="text-left mg-bottom-10">
                <button
                  type="submit"
                  className="addBtnn2 mng-padding"
                  onClick={() => toggleAddOrEditBreakDownPopUp(dispatch, true)}
                >
                  <AddIcon className="mr-2 addIconSc " />
                  {""}Add New Breakdown Data
                </button>
              </div>
              <Paper className="pd-top-10 shadow">
                <CustomSearch
                  searchQuery={searchQuery}
                  searchedRecord={searchedRecord}
                  setSearchedRecord={setSearchedRecord}
                  setSearchQuery={setSearchQuery}
                  getDataByPage={(page, pageSize) =>
                    setBreakDownList(dispatch, {
                      page,
                      pageSize,
                      currentUserId,
                      defaultColumnSetName: selectedColumnSet?.columnName,
                    })
                  }
                  searchData={searchBreakDownData}
                  pageState={BreakDownList}
                  setRecordNotFound={() => {}}
                />
                <DataGrid
                  rows={BreakDownList?.data}
                  rowCount={BreakDownList?.totalRecords}
                  pagination
                  page={BreakDownList?.page}
                  pageSize={BreakDownList?.pageSize}
                  columns={ManageBreakDownTableColumns}
                  rowsPerPageOptions={[10]}
                  paginationMode="server"
                  getRowId={(row) => row?.id}
                  onPageChange={(newPage) => {
                    if (searchQuery == "") {
                      setBreakDownList(dispatch, {
                        page: newPage,
                        pageSize: 10,
                        currentUserId,
                        defaultColumnSetName: selectedColumnSet?.columnName,
                      });
                    } else {
                      searchBreakDownData(searchQuery, newPage, 10);
                    }
                  }}
                  sx={{
                    color: "black",
                    fontFamily: "Rajdhani-SemiBold",
                    fontSize: "18px",
                    backgroundColor: "white",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                  autoHeight
                  disableColumnMenu
                  getRowHeight={() => "auto"}
                  disableSelectionOnClick
                  getRowClassName={(params) => {
                    const index = params?.indexRelativeToCurrentPage + 1;
                    return index % 2 === 0 ? styles.evenRow : styles.oddRow;
                  }}
                  onCellClick={handleRowClick}
                />
              </Paper>
            </>
          )}
        </div>
        {(tableLoading || loading) && (
          <div
            className={`d-flex align-items-center justify-content-center w-100 blur-filter-background ${
              tableLoading ? "h-400" : "h-100 position-absolute top-0 left-0"
            }`}
          >
            <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
              <CircularProgress
                className="rounded-circle"
                color="success"
                sx={{
                  fontSize: 10,
                  color: "#002244",
                  border: "2px solid red",
                }}
                disableShrink
              />
            </div>
          </div>
        )}
      </DialogBox>
      <AddOrEditBreakDown
        searchQuery={searchQuery}
        page={BreakDownList?.page}
        pageSize={BreakDownList?.pageSize}
        defaultColumnSetName={selectedColumnSet?.columnName}
      />
    </div>
  );
};

export default ManageBreakDownModel;
